import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiEndpoints } from '@core/constants/api-endpoints';

@Injectable({ providedIn: 'root' })
export class ExpenseService {

  constructor(private readonly api: ApiService) {}

  list(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.EXPENSE_LIST, payload);
  }

  create(payload: any): Observable<any> {
    return this.api.postHandler(ApiEndpoints.EXPENSE_CREATE, payload);
  }

  update(payload: any): Observable<any> {
    return this.api.postHandler(ApiEndpoints.EXPENSE_UPDATE, payload);
  }

  delete(payload: { id: number | string }): Observable<any> {
    return this.api.postHandler(ApiEndpoints.EXPENSE_DELETE, payload);
  }

  yearlySummary(payload: any = {}): Observable<any> {
    return this.api.postHandler(ApiEndpoints.YEARLY_EXPENSE_SUMMARY, payload);
  }

}
